<script>
import { Line } from 'vue-chartjs'
import { mapGetters } from 'vuex'
export default {
  extends: Line,
  props: {
    datasetLabel: {
      type: String,
      required: true
    },
    scaleLabelX: {
      type: String,
      required: true
    },
    scaleAttribute: {
      type: String,
      required: true
    },
    scaleAttributeJurisdiction: {
      type: Boolean,
      default: false
    },
    datasetAttribute: {
      type: String,
      required: true
    },
    patternScaleY: {
      type: String,
      default: null
    },
    sbs: {
      // side by side
      type: Boolean,
      default: false
    },
    avg: {
      type: Boolean,
      default: false
    },
    total: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scalePatterns: [
        {
          value: 'gordura',
          ticks: {
            suggestedMax: 7,
            stepSize: 0.5,
            beginAtZero: true
          }
        },
        {
          value: 'cpp',
          ticks: {
            stepSize: 500,
            beginAtZero: true
          }
        },
        {
          value: 'ccs',
          ticks: {
            stepSize: 500,
            beginAtZero: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['relatorio']),
    dataLabels () {
      if (this.avg || this.total) {
        return this.relatorio.map(item => item[this.scaleAttribute])
      }
      return this.relatorio.map(item =>
        this.scaleAttributeJurisdiction
          ? this.$options.filters.jurisdiction(item[this.scaleAttribute])
          : this.$options.filters.date(item[this.scaleAttribute])
      )
    },
    dataFromReport () {
      return this.relatorio.map(item => item[this.datasetAttribute])
    },
    data () {
      return {
        labels: this.dataLabels,
        datasets: [
          {
            fill: false,
            label: this.datasetLabel,
            borderColor: '#2196F3',
            data: this.dataFromReport
          }
        ]
      }
    },
    options () {
      return this.sbs
        ? {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: 'index',
            intersect: true
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          layout: {
            padding: {
              left: 25,
              right: 55,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: this.scaleLabelX
                }
              }
            ],
            yAxes: [
              {
                display: true,
                ticks: this.getScaleYPattern(this.patternScaleY)
              }
            ]
          }
        }
        : {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 20,
              right: 20,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: this.scaleLabelX
                }
              }
            ],
            yAxes: [
              {
                display: true,
                ticks: this.getScaleYPattern(this.patternScaleY)
              }
            ]
          }
        }
    }
  },
  methods: {
    getScaleYPattern (type) {
      if (!type) return {}
      if (this.scalePatterns.findIndex(item => item.value === type) === -1) return {}
      return this.scalePatterns.find(item => item.value === type).ticks
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>
